module.exports = "data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAABgAAAAYBAMAAAASWSDLAAAAG1BMVEUAAAA8PDw8PDw8PDw8PDw7Ozs4ODg9PT09PT0lzPh5AAAACHRSTlMAxfK8iFIpFcrhoIAAAAAwSURBVBjTYyAWSHRAQSOQ0wEH1OE0cIAgGof69qB4obkA4bkOBySfqiJ7OwFHcAAAGZZUG3P28qUAAAAASUVORK5CYII="


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/aboutus/content_email.png
// module id = u907
// module chunks = 44